import { diffLines } from "diff";

/** 行内 diff（Edit 工具的 old_string → new_string） */
export function InlineDiff({ before, after }: { before: string; after: string }) {
  const parts = diffLines(before, after);
  return (
    <pre className="idiff" data-testid="inline-diff">
      {parts.flatMap((p, i) =>
        p.value
          .replace(/\n$/, "")
          .split("\n")
          .map((line, j) => (
            <div key={`${i}-${j}`} className={p.added ? "idiff__add" : p.removed ? "idiff__del" : "idiff__ctx"}>
              <span className="idiff__sign">
                {p.added ? "+" : p.removed ? "-" : " "}
              </span>
              {line}
            </div>
          )),
      )}
    </pre>
  );
}
